module.exports = __webpack_public_path__ + "img/sterren.a37244a1.jpg";